<template>
  <span>
    <b-button
      v-b-tooltip.hover.right
      v-bind:title="alertName"
      pill
      :variant="alertColor"
      @click="showModal"
      size="sm"
      v-if="alertTypeId">
      <i :class="alertIcon"></i>
    </b-button>

    <b-button pill variant="outline-secondary" @click="showModal" size="sm" v-if="!alertTypeId">
        <i class="fa fa-plus-circle"></i>
    </b-button>

    <b-modal
      id="product-alert-modal"
      ref="product-alert-modal"
      size="md"
      ok-title="Save"
      :ok-disabled="!choosenType || !newMessage"
      title="Inventory Alert"
      cancel-title="Delete"
      cancel-variant="danger"
      :cancel-disabled="!alertTypeId"
      modal-header-close
      @ok="handleSave"
      @cancel="handleDelete"
    >
      <b-form-group label="Alert type">
        <b-form-select
          id="alertTye"
          v-model="choosenType"
          :plain="true"
          @change="onChange"
          :options="alertTypesOptions"
        />
      </b-form-group>
      <form id="add-lookup-form">
        <b-form-group label="Attach an alert to this inventory item">
          <b-form-textarea v-model="newMessage" type="textarea" size="sm"></b-form-textarea>
        </b-form-group>
      </form>
    </b-modal>
  </span>
</template>

<script>
import { mapActions } from 'vuex';
import { ALERT_ICON, ALERT_COLOR, ALERT_NAME } from './constants';
import productAlertService from './service';

export default {
  props: {
    message: String,
    alertTypeId: Number,
    inventoryId: Number,
    location: String,
  },
  data() {
    return {
      choosenType: null,
      newMessage: null,
      alertTypes: [],
    };
  },
  computed: {
    alertIcon() {
      return `fa fa-${ALERT_ICON[this.alertTypeId]}`;
    },
    alertColor() {
      return ALERT_COLOR[this.alertTypeId];
    },
    alertName() {
      return ALERT_NAME[this.alertTypeId];
    },
    alertTypesOptions() {
      return this.alertTypes.map(alertType => ({
        value: alertType.id,
        text: alertType.name,
      }));
    },
  },
  methods: {
    ...mapActions('inventory', ['updateProductAlert', 'removeProductAlert']),
    onChange(value) {
      this.choosenType = value;
    },
    async showModal() {
      this.$refs['product-alert-modal'].show();
      this.alertTypes = await productAlertService.getInventoryAlertTypes();
      this.choosenType = this.alertTypeId,
      this.newMessage = this.message
    },
    async handleSave() {
      const params = {
        id: this.inventoryId,
        choosenType: this.choosenType,
        newMessage: this.newMessage,
        location: this.location,
      };
      this.updateProductAlert(params);
    },
    async handleDelete() {
      const params = {
        id: this.inventoryId,
        location: this.location,
      };
      this.removeProductAlert(params);
    },
  },
};
</script>

<style lang="scss">
.lookup-dropdown {
  &--plus {
    font-size: 10px;
  }
}
</style>

